import { useEffect } from 'react';
import { isEmpty } from 'lodash-es';
import { DateTime } from 'luxon';
import { Amplitude } from '@namespace/cms/src/api/getSiteSettings/schemes/siteSettings/otherSettings/amplitude';
import { AMPLITUDE_VIP_STATUSES } from '../constants';
import { AmplitudeVipStatusKeys, DateHelper, User } from './types';

const useAmplitude = (
  user: User,
  amplitude: Amplitude,
  isNotVerified: boolean,
  f: DateHelper,
  isMobile: boolean
): void => {
  const { title, vipStatus, dateOfBirth, id: userId } = user;

  useEffect(() => {
    if (window.amplitude && userId) {
      const { web } = amplitude || {};
      const { enableUserProperties = false } = web || {};
      window.amplitude.setUserId(userId);

      if (enableUserProperties && !isNotVerified) {
        const identifyEvent = new window.amplitude.Identify();

        if (!isEmpty(vipStatus)) {
          const mappedVipStatuses = vipStatus.map((status) => {
            return (
              AMPLITUDE_VIP_STATUSES[status as AmplitudeVipStatusKeys] || status
            );
          });
          identifyEvent.set('vip_status', mappedVipStatuses);
        }

        if (dateOfBirth) {
          const age = Math.floor(
            DateTime.local().diff(
              f.getDateTime({
                date: dateOfBirth
              }),
              'years'
            ).years
          );
          identifyEvent.set('age', age);
        }

        if (title) {
          identifyEvent.set('gender', title);
        }

        identifyEvent.set(
          'platform_details',
          isMobile ? 'mobile_web' : 'desktop_web'
        );

        window.amplitude.identify(identifyEvent);
      }
    }
  }, [
    amplitude,
    dateOfBirth,
    isNotVerified,
    title,
    userId,
    vipStatus,
    isMobile
  ]);
};

export default useAmplitude;
